import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import { ICurrentProject } from '~/src/services/projects';

export const updateElement = (project: ICurrentProject, id: string, name: string, value: string): ICurrentProject => {
    const { body } = project;
    const changePropsKey = name.substring(body[id].type.length + 1);
    const currentProp = cloneDeep(body[id]);

    set(currentProp, changePropsKey, value);

    return {
        ...project,
        body: {
            ...body,
            [id]: currentProp,
        },
    };
};

export const updateProject = (project: ICurrentProject, name: string, value: string): ICurrentProject => {
    const changePropsKey = name.substring(project.type.length + 1);
    const currentProp = cloneDeep(project);

    set(currentProp, changePropsKey, value);

    return {
        ...project,
        ...currentProp,
    };
};
